{
  "tabs": {
    "chat": "ਚੈਟ",
    "reminders": "ਰਿਮਾਈਂਡਰ",
    "calendar": "ਕੈਲੰਡਰ",
    "settings": "ਸੈਟਿੰਗ"
  },
  "common": {
    "cancel": "ਰੱਦ ਕਰੋ",
    "save": "ਸੰਭਾਲੋ",
    "confirm": "ਪੁਸ਼ਟੀ ਕਰੋ",
    "delete": "ਹਟਾਓ",
    "back": "ਵਾਪਸ",
    "close": "ਬੰਦ ਕਰੋ",
    "edit": "ਸੰਪਾਦਿਤ ਕਰੋ",
    "search": "ਖੋਜੋ",
    "all": "ਸਭ",
    "loading": "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
    "error": "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ",
    "notFound": "ਮਿਲਿਆ ਨਹੀਂ",
    "tryAgain": "ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "retry": "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
    "undo": "ਵਾਪਸ ਲਓ",
    "pullToRefresh": "ਤਾਜ਼ਾ ਕਰਨ ਲਈ ਖਿੱਚੋ",
    "justNow": "ਹੁਣੇ ਹੀ"
  },
  "auth": {
    "welcome": "FishMemory ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    "tagline": "ਤੁਹਾਡਾ WhatsApp ਰਿਮਾਈਂਡਰ ਸਹਾਇਕ, ਹੁਣ ਤੁਹਾਡੇ ਜੇਬ ਵਿੱਚ।",
    "subtitle": "ਤੁਹਾਡਾ WhatsApp ਰਿਮਾਈਂਡਰ ਸਹਾਇਕ, ਹੁਣ ਤੁਹਾਡੇ ਜੇਬ ਵਿੱਚ।",
    "phoneLabel": "ਤੁਹਾਡਾ WhatsApp ਨੰਬਰ",
    "phoneHint": "ਅਸੀਂ WhatsApp ਰਾਹੀਂ ਇੱਕ ਵੈਰੀਫਿਕੇਸ਼ਨ ਕੋਡ ਭੇਜਾਂਗੇ",
    "invalidPhone": "ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ ਫੋਨ ਨੰਬਰ ਦਿਓ",
    "continue": "ਜਾਰੀ ਰੱਖੋ",
    "enterPhone": "ਆਪਣਾ WhatsApp ਨੰਬਰ ਦਿਓ",
    "phonePlaceholder": "ਫੋਨ ਨੰਬਰ",
    "sendCode": "ਕੋਡ ਭੇਜੋ",
    "verifyTitle": "ਆਪਣਾ ਨੰਬਰ ਸੱਚੋ",
    "otpSentTo": "6 ਅੰਕਾਂ ਦਾ ਕੋਡ {{phone}} ਤੇ WhatsApp ਰਾਹੀਂ ਭੇਜਿਆ ਗਿਆ",
    "enterFullCode": "ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ 6 ਅੰਕ ਦਿਓ",
    "invalidOtp": "ਗਲਤ ਕੋਡ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "otpFailed": "ਕੋਡ ਭੇਜਣ ਵਿੱਚ ਅਸਫਲ। ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "otpResent": "ਕੋਡ ਮੁੜ ਭੇਜਿਆ ਗਿਆ",
    "resendIn": "{{seconds}} ਸਕਿੰਟ ਵਿੱਚ ਮੁੜ ਭੇਜੋ",
    "resendCode": "ਕੋਡ ਮੁੜ ਭੇਜੋ",
    "enterOtp": "WhatsApp ਤੇ ਭੇਜੇ ਕੋਡ ਦਿਓ",
    "verify": "ਸੱਚੋ",
    "resend": "ਕੋਡ ਮੁੜ ਭੇਜੋ",
    "wrongNumber": "ਗਲਤ ਨੰਬਰ?",
    "backToPhone": "ਫੋਨ ਤੇ ਵਾਪਸ ਜਾਓ",
    "editPhone": "ਫੋਨ ਨੰਬਰ ਸੋਧੋ",
    "error": "ਗਲਤੀ",
    "setupTitle": "ਆਓ ਸੈਟਅਪ ਕਰੀਏ",
    "setupSubtitle": "ਤੁਸੀਂ ਇਹ ਬਾਅਦ ਵਿੱਚ ਸੈਟਿੰਗ ਵਿੱਚ ਬਦਲ ਸਕਦੇ ਹੋ",
    "namePlaceholder": "ਤੁਹਾਡਾ ਨਾਮ",
    "letsGo": "ਸੈਟਅਪ ਮੁਕੰਮਲ ਕਰੋ",
    "skipForNow": "ਹੁਣ ਲਈ ਛੱਡੋ"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "ਸੁਨੇਹਾ ਲਿਖੋ...",
    "inputPlaceholder": "ਸੁਨੇਹਾ ਲਿਖੋ...",
    "typing": "FishMemory ਲਿਖ ਰਿਹਾ ਹੈ...",
    "online": "ਆਨਲਾਈਨ",
    "connecting": "ਜੁੜ ਰਿਹਾ ਹੈ...",
    "reconnecting": "ਮੁੜ ਜੁੜ ਰਿਹਾ ਹੈ...",
    "offline": "ਆਫਲਾਈਨ",
    "empty": "ਗੱਲਬਾਤ ਸ਼ੁਰੂ ਕਰੋ",
    "emptyHint": "ਰਿਮਾਈਂਡਰ ਬਣਾਓ, ਆਪਣਾ ਸ਼ਡਿਊਲ ਵੇਖੋ ਜਾਂ ਮਦਦ ਮੰਗੋ।",
    "emptyAction": "ਨਮੂਨਾ ਰਿਮਾਈਂਡਰ ਭੇਜੋ",
    "actions": "ਚੈਟ ਕਾਰਵਾਈਆਂ",
    "keep": "ਸੁਨੇਹੇ ਰੱਖੋ",
    "clearTitle": "ਚੈਟ ਸਾਫ਼ ਕਰੋ",
    "clearConfirm": "ਕੀ ਤੁਸੀਂ ਇਸ ਡਿਵਾਈਸ ਤੋਂ ਸਾਰੇ ਸੁਨੇਹੇ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ? ਇਹ ਮੁੜ ਨਹੀਂ ਹੋ ਸਕਦਾ।",
    "clear": "ਚੈਟ ਸਾਫ਼ ਕਰੋ",
    "optionSelected": "ਚੁਣਿਆ: {{label}}",
    "sendingSelection": "ਭੇਜ ਰਿਹਾ ਹੈ...",
    "connectionLost": "ਮੁੜ ਜੁੜ ਰਿਹਾ ਹੈ..."
  },
  "reminders": {
    "title": "ਮੇਰੇ ਰਿਮਾਈਂਡਰ",
    "active": "ਸਰਗਰਮ",
    "today": "ਅੱਜ",
    "thisWeek": "ਇਸ ਹਫ਼ਤੇ",
    "history": "ਇਤਿਹਾਸ",
    "items": "ਆਈਟਮ",
    "emptyTitle": "ਕੋਈ ਰਿਮਾਈਂਡਰ ਨਹੀਂ",
    "emptySubtitle": "ਚੈਟ ਤੋਂ ਬਣਾਓ, ਇਹ ਇੱਥੇ ਦਿਖੇਗਾ।",
    "emptyAction": "ਚੈਟ ਖੋਲ੍ਹੋ",
    "filterActive": "ਸਰਗਰਮ",
    "filterToday": "ਅੱਜ",
    "filterWeek": "ਇਸ ਹਫ਼ਤੇ",
    "filterHistory": "ਇਤਿਹਾਸ",
    "emptyState": "ਕੋਈ ਰਿਮਾਈਂਡਰ ਨਹੀਂ। ਗੱਲਬਾਤ ਸ਼ੁਰੂ ਕਰੋ!",
    "swipeDone": "ਮੁਕੰਮਲ",
    "swipeSnooze": "ਸੂਜ਼",
    "swipeDelete": "ਹਟਾਓ",
    "search": "ਰਿਮਾਈਂਡਰ ਖੋਜੋ...",
    "upcoming": "ਆਉਣ ਵਾਲੇ",
    "completed": "ਮੁਕੰਮਲ",
    "overdue": "ਮਿਆਦ ਖਤਮ",
    "tomorrow": "ਕੱਲ੍ਹ",
    "synced": "ਸਿੰਕ ਕੀਤਾ {{value}}",
    "swipeHint": "ਹੋਰ ਕਾਰਵਾਈ ਲਈ ਰਿਮਾਈਂਡਰ ਨੂੰ ਸਵਾਈਪ ਕਰੋ",
    "noResults": "ਤੁਹਾਡੇ ਖੋਜ ਨਾਲ ਕੋਈ ਰਿਮਾਈਂਡਰ ਨਹੀਂ ਮਿਲੇ",
    "noResultsHint": "ਵੱਖਰਾ ਕੀਵਰਡ ਆਜ਼ਮਾਓ ਜਾਂ ਖੋਜ ਸਾਫ਼ ਕਰੋ",
    "deleteAllFailed": "ਸਾਰੇ ਰਿਮਾਈਂਡਰ ਹਟਾਉਣ ਵਿੱਚ ਅਸਫਲ"
  },
  "calendar": {
    "title": "ਕੈਲੰਡਰ",
    "today": "ਅੱਜ",
    "tomorrow": "ਕੱਲ੍ਹ",
    "completed": "ਮੁਕੰਮਲ",
    "noEvents": "ਕੋਈ ਇਵੈਂਟ ਨਹੀਂ",
    "noEventsSubtitle": "ਰਿਮਾਈਂਡਰ ਅਤੇ ਕੈਲੰਡਰ ਇਵੈਂਟ ਵੇਖਣ ਲਈ ਤਾਰੀਖ ਚੁਣੋ।",
    "googleEvent": "Google ਕੈਲੰਡਰ",
    "legendActive": "ਸਰਗਰਮ",
    "legendRecurring": "ਦੁਹਰਾਉਂਦਾ",
    "legendDone": "ਮੁਕੰਮਲ",
    "legendGoogle": "ਗੂਗਲ",
    "previousMonth": "ਪਿਛਲਾ ਮਹੀਨਾ",
    "nextMonth": "ਅਗਲਾ ਮਹੀਨਾ",
    "previousYear": "ਪਿਛਲਾ ਸਾਲ",
    "nextYear": "ਅਗਲਾ ਸਾਲ",
    "goToToday": "ਅੱਜ ਤੇ ਜਾਓ",
    "all": "ਸਭ",
    "active": "ਸਰਗਰਮ",
    "done": "ਮੁਕੰਮਲ",
    "paused": "ਰੋਕਿਆ"
  },
  "settings": {
    "title": "ਸੈਟਿੰਗ",
    "profile": "ਪ੍ਰੋਫਾਈਲ",
    "name": "ਦਿਖਾਉਣ ਵਾਲਾ ਨਾਮ",
    "enterName": "ਆਪਣਾ ਨਾਮ ਦਿਓ",
    "language": "ਭਾਸ਼ਾ",
    "uiLanguage": "ਐਪ ਭਾਸ਼ਾ",
    "uiLanguageHelp": "ਇਸ ਡਿਵਾਈਸ ਲਈ ਐਪ UI, ਕੈਲੰਡਰ ਲੇਬਲ ਅਤੇ ਲੇਆਉਟ ਦਿਸ਼ਾ ਬਦਲਦਾ ਹੈ।",
    "serverLanguage": "ਚੈਟ ਭਾਸ਼ਾ",
    "serverLanguageHelp": "ਤੁਹਾਡੇ ਖਾਤੇ ਲਈ ਸਰਵਰ ਜਵਾਬ ਅਤੇ ਰਿਮਾਈਂਡਰ ਸੁਨੇਹਿਆਂ ਦੀ ਭਾਸ਼ਾ ਬਦਲਦਾ ਹੈ।",
    "timezone": "ਟਾਈਮਜ਼ੋਨ",
    "currentTimezone": "ਮੌਜੂਦਾ ਟਾਈਮਜ਼ੋਨ",
    "timezoneHelp": "ਸਾਰੇ ਰਿਮਾਈਂਡਰ ਸਮੇਂ ਇਸ ਟਾਈਮਜ਼ੋਨ ਵਿੱਚ ਦਿਖਾਏ ਜਾਂਦੇ ਹਨ।",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ਟਾਈਮਜ਼ੋਨ ਸੰਭਾਲੋ",
    "timezoneSaved": "ਟਾਈਮਜ਼ੋਨ ਅਪਡੇਟ ਹੋਇਆ",
    "detect": "ਪਤਾ ਲਗਾਓ",
    "detectFailed": "ਟਾਈਮਜ਼ੋਨ ਪਤਾ ਨਹੀਂ ਲੱਗਿਆ",
    "autoDetect": "GPS ਤੋਂ ਆਟੋ-ਪਤਾ ਲਗਾਓ",
    "notifications": "ਸੂਚਨਾਵਾਂ",
    "notificationsHelp": "ਫਾਲੋ-ਅੱਪ ਰਿਮਾਈਂਡਰ ਦੁਹਰਾਈਆਂ ਸੂਚਨਾਵਾਂ ਨੂੰ ਨਿਯੰਤਰਿਤ ਕਰਦੇ ਹਨ। ਡਿਵਾਈਸ-ਸਤਰ ਸੂਚਨਾ ਅਧਿਕਾਰ ਫੋਨ ਸੈਟਿੰਗ ਵਿੱਚ ਹੁੰਦੇ ਹਨ।",
    "pushEnabled": "ਪੁਸ਼ ਸੂਚਨਾਵਾਂ",
    "autoDoneOnFire": "ਫਾਇਰ ਹੋਣ 'ਤੇ ਆਟੋ-ਮਾਰਕ ਮੁਕੰਮਲ",
    "autoDoneOnFireDesc": "ਬੰਦ ਹੋਣ 'ਤੇ, ਰਿਮਾਈਂਡਰ ਸਰਗਰਮ ਰਹਿੰਦੇ ਹਨ ਜਦ ਤੱਕ ਤੁਸੀਂ ਉਹਨਾਂ ਨੂੰ ਮੁਕੰਮਲ ਨਾ ਕਰੋ।",
    "googleCalendar": "Google ਕੈਲੰਡਰ",
    "google": "Google ਕੈਲੰਡਰ",
    "googleConnected": "ਜੁੜਿਆ",
    "googleDisconnected": "ਨਹੀਂ ਜੁੜਿਆ",
    "googleConnectedHelp": "ਨਵੇਂ ਰਿਮਾਈਂਡਰ ਆਪਣੇ ਕੈਲੰਡਰ ਨਾਲ ਆਟੋਮੈਟਿਕ ਸਿੰਕ ਹੋ ਸਕਦੇ ਹਨ।",
    "googleDisconnectedHelp": "Google ਕੈਲੰਡਰ ਜੋੜੋ ਤਾਂ ਜੋ ਰਿਮਾਈਂਡਰ ਅਤੇ ਇਵੈਂਟ ਸਹੀ ਰਹਿਣ।",
    "googleConnectFailed": "Google ਕੈਲੰਡਰ ਜੁੜਨ ਵਿੱਚ ਅਸਫਲ",
    "connected": "ਜੁੜਿਆ",
    "disconnected": "ਨਹੀਂ ਜੁੜਿਆ",
    "connect": "ਜੋੜੋ",
    "disconnect": "ਅਲੱਗ ਕਰੋ",
    "autoSync": "ਨਵੇਂ ਰਿਮਾਈਂਡਰ ਆਟੋ-ਸਿੰਕ",
    "autosync": "ਨਵੇਂ ਰਿਮਾਈਂਡਰ ਆਟੋ-ਸਿੰਕ",
    "subscription": "ਸਬਸਕ੍ਰਿਪਸ਼ਨ",
    "trialUsed": "ਟ੍ਰਾਇਲ: {{used}}/{{total}} ਵਰਤੇ",
    "trialStatus": "ਟ੍ਰਾਇਲ ਉਪਲਬਧ",
    "activeStatus": "ਸਰਗਰਮ ਸਬਸਕ੍ਰਿਪਸ਼ਨ",
    "expiredStatus": "ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਮਿਆਦ ਖਤਮ",
    "unsubscribedStatus": "ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਨਹੀਂ",
    "about": "ਬਾਰੇ",
    "version": "ਵਰਜ਼ਨ",
    "logout": "ਲੌਗ ਆਉਟ",
    "logoutTitle": "ਲੌਗ ਆਉਟ",
    "logoutConfirm": "ਕੀ ਤੁਸੀਂ ਲੌਗ ਆਉਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    "noName": "ਕੋਈ ਨਾਮ ਨਹੀਂ",
    "serverConnection": "ਸਰਵਰ ਕਨੈਕਸ਼ਨ",
    "serverUrl": "ਸਰਵਰ URL",
    "serverEdit": "ਸੋਧੋ",
    "saveReconnect": "ਸੰਭਾਲੋ ਅਤੇ ਮੁੜ ਜੁੜੋ",
    "resetDefault": "ਡਿਫਾਲਟ ਰੀਸੈੱਟ ਕਰੋ",
    "invalidServerUrlTitle": "ਗਲਤ ਸਰਵਰ URL",
    "invalidServerUrlMessage": "ਕਿਰਪਾ ਕਰਕੇ ਸਹੀ http ਜਾਂ https ਸਰਵਰ URL ਦਿਓ, ਜਿਵੇਂ https://example.com",
    "uiLanguageChangeFailed": "ਐਪ ਭਾਸ਼ਾ ਬਦਲਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "serverLanguageChangeFailed": "ਚੈਟ ਭਾਸ਼ਾ ਬਦਲਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "timezoneChangeFailed": "ਟਾਈਮਜ਼ੋਨ ਬਦਲਣ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "autoSyncChangeFailed": "ਆਟੋ-ਸਿੰਕ ਅਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "nameChangeFailed": "ਦਿਖਾਉਣ ਵਾਲਾ ਨਾਮ ਅਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ਰਿਮਾਈਂਡਰ ਵੇਰਵੇ",
    "editTime": "ਸਮਾਂ ਸੋਧੋ",
    "rename": "ਨਾਮ ਬਦਲੋ",
    "snooze": "ਸੂਜ਼ ਕਰੋ",
    "snooze15": "15 ਮਿੰਟ ਲਈ ਸੂਜ਼ ਕਰੋ",
    "pause": "ਰੋਕੋ",
    "pauseReminder": "ਰਿਮਾਈਂਡਰ ਰੋਕੋ",
    "resume": "ਜਾਰੀ ਰੱਖੋ",
    "resumeReminder": "ਰਿਮਾਈਂਡਰ ਜਾਰੀ ਰੱਖੋ",
    "skip": "ਅਗਲਾ ਛੱਡੋ",
    "skipOccurrence": "ਇਸ ਵਾਰ ਛੱਡੋ",
    "syncGoogle": "Google ਨਾਲ ਸਿੰਕ ਕਰੋ",
    "delete": "ਹਟਾਓ",
    "deleteTitle": "ਰਿਮਾਈਂਡਰ ਹਟਾਓ",
    "deleteConfirm": "ਇਹ ਰਿਮਾਈਂਡਰ ਸਥਾਈ ਤੌਰ 'ਤੇ ਹਟਾਇਆ ਜਾਵੇਗਾ।",
    "deleteRecurringTitle": "ਦੁਹਰਾਉਂਦੇ ਰਿਮਾਈਂਡਰ ਹਟਾਓ",
    "deleteRecurringMessage": "ਕੀ ਤੁਸੀਂ ਇਸ ਵਾਰ ਛੱਡਣਾ ਚਾਹੁੰਦੇ ਹੋ ਜਾਂ ਸਾਰੀ ਸੀਰੀਜ਼ ਹਟਾਉਣੀ ਹੈ?",
    "deleteThisOccurrence": "ਇਸ ਵਾਰ ਛੱਡੋ",
    "deleteEntireSeries": "ਸਾਰੀ ਸੀਰੀਜ਼ ਹਟਾਓ",
    "done": "ਮੁਕੰਮਲ",
    "markDone": "ਮੁਕੰਮਲ ਮਾਰਕ ਕਰੋ",
    "undo": "ਵਾਪਸ ਲਓ",
    "undoPrompt": "ਫਿਰ ਸਰਗਰਮ ਕਰਨਾ ਹੈ? ਹੁਣ ਵਾਪਸ ਲਓ।",
    "recurring": "ਦੁਹਰਾਉਂਦਾ",
    "nextRun": "ਅਗਲੀ ਚਲਾਣ",
    "oneTime": "ਇੱਕ ਵਾਰੀ",
    "pending": "ਬਕਾਇਆ",
    "sent": "ਭੇਜਿਆ",
    "paused": "ਰੋਕਿਆ",
    "active": "ਸਰਗਰਮ",
    "snoozed": "ਸੂਜ਼ ਕੀਤਾ",
    "localTime": "ਤੁਹਾਡੇ ਸਥਾਨਕ ਸਮੇਂ ਵਿੱਚ ਦਿਖਾਇਆ ਗਿਆ",
    "recurrence": "ਦੁਹਰਾਉ",
    "created": "ਬਣਾਇਆ",
    "tags": "ਟੈਗ",
    "fireCount": "ਵਾਰ ਚਲਾਇਆ",
    "actions": "ਕਾਰਵਾਈਆਂ",
    "none": "ਕੋਈ ਨਹੀਂ",
    "snoozeFailed": "ਰਿਮਾਈਂਡਰ ਸੂਜ਼ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "pauseFailed": "ਰਿਮਾਈਂਡਰ ਰੋਕਣ ਵਿੱਚ ਅਸਫਲ",
    "resumeFailed": "ਰਿਮਾਈਂਡਰ ਜਾਰੀ ਰੱਖਣ ਵਿੱਚ ਅਸਫਲ",
    "skipFailed": "ਰਿਮਾਈਂਡਰ ਛੱਡਣ ਵਿੱਚ ਅਸਫਲ",
    "doneFailed": "ਰਿਮਾਈਂਡਰ ਮੁਕੰਮਲ ਮਾਰਕ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "undoFailed": "ਰਿਮਾਈਂਡਰ ਸਥਿਤੀ ਵਾਪਸ ਲੈਣ ਵਿੱਚ ਅਸਫਲ",
    "deleteFailed": "ਰਿਮਾਈਂਡਰ ਹਟਾਉਣ ਵਿੱਚ ਅਸਫਲ",
    "rescheduleTitle": "ਮੁੜ ਤਯਾਰ ਕਰਨਾ?",
    "rescheduleMsg": "ਇਹ ਰਿਮਾਈਂਡਰ ਮਿਆਦ ਖਤਮ ਹੋ ਚੁੱਕਾ ਹੈ। ਕੀ ਤੁਸੀਂ ਇਸ ਨੂੰ ਮੁੜ ਤਯਾਰ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    "reschedule15": "15 ਮਿੰਟ ਵਿੱਚ",
    "reschedule60": "1 ਘੰਟੇ ਵਿੱਚ",
    "keepOverdue": "ਜਿਵੇਂ ਹੈ ਰੱਖੋ"
  },
  "onboarding": {
    "slide1Title": "FishMemory ਵਿੱਚ ਤੁਹਾਡਾ ਸਵਾਗਤ ਹੈ",
    "slide1Sub": "ਤੁਹਾਡਾ ਨਿੱਜੀ ਰਿਮਾਈਂਡਰ ਸਹਾਇਕ — WhatsApp ਨਾਲ ਚਲਦਾ ਅਤੇ ਤੁਹਾਡੇ ਜੇਬ ਲਈ ਬਣਾਇਆ।",
    "slide2Title": "ਸਧਾਰਣ ਗੱਲਬਾਤ ਕਰੋ",
    "slide2Sub": "ਜਿਵੇਂ ਸੋਚਦੇ ਹੋ, ਉਸੇ ਤਰ੍ਹਾਂ ਰਿਮਾਈਂਡਰ ਲਿਖੋ: \"ਮੈਨੂੰ ਕੱਲ੍ਹ 3 ਵਜੇ ਮਾਂ ਨੂੰ ਕਾਲ ਕਰਨ ਲਈ ਯਾਦ ਦਿਵਾਓ\" — ਬਾਕੀ ਅਸੀਂ ਸੰਭਾਲਾਂਗੇ।",
    "slide3Title": "ਕਦੇ ਵੀ ਕੁਝ ਨਾ ਛੱਡੋ",
    "slide3Sub": "ਸਮੇਂ ਸਿਰ ਸੂਚਨਾਵਾਂ ਪ੍ਰਾਪਤ ਕਰੋ, ਟੈਗ ਨਾਲ ਸੰਗਠਿਤ ਰਹੋ, ਅਤੇ ਸਭ ਕੁਝ ਜੋ ਮਹੱਤਵਪੂਰਨ ਹੈ ਉਸ 'ਤੇ ਨਜ਼ਰ ਰੱਖੋ।",
    "getStarted": "ਸ਼ੁਰੂ ਕਰੋ",
    "next": "ਅਗਲਾ",
    "firstReminderTitle": "ਆਪਣਾ ਪਹਿਲਾ ਰਿਮਾਈਂਡਰ ਬਣਾਓ!",
    "firstReminderHint": "ਇਸ ਤਰ੍ਹਾਂ ਕੁਝ ਲਿਖ ਕੇ ਕੋਸ਼ਿਸ਼ ਕਰੋ:",
    "firstReminderExample": "ਮੈਨੂੰ ਕੱਲ੍ਹ 9 ਵਜੇ ਪਾਣੀ ਪੀਣ ਲਈ ਯਾਦ ਦਿਵਾਓ",
    "gotIt": "ਸਮਝ ਗਿਆ!",
    "notifRationaleTitle": "ਸਮੇਂ 'ਤੇ ਰਹੋ",
    "notifRationaleBody": "FishMemory ਨੂੰ ਸਮੇਂ 'ਤੇ ਯਾਦ ਦਿਵਾਉਣ ਲਈ ਸੂਚਨਾਵਾਂ ਦੀ ਲੋੜ ਹੈ। ਤੁਹਾਨੂੰ ਸਿਰਫ਼ ਉਹਨਾਂ ਰਿਮਾਈਂਡਰਾਂ ਲਈ ਸੂਚਨਾਵਾਂ ਮਿਲਣਗੀਆਂ ਜੋ ਤੁਸੀਂ ਬਣਾਉਂਦੇ ਹੋ।",
    "notifRationaleAllow": "ਸੂਚਨਾਵਾਂ ਚਾਲੂ ਕਰੋ",
    "notifRationaleLater": "ਸ਼ਾਇਦ ਬਾਅਦ ਵਿੱਚ",
    "swipeHint": "ਤੇਜ਼ ਕਾਰਵਾਈ ਲਈ ਸੱਜੇ ਵੱਲ ਸਵਾਈਪ ਕਰੋ →",
    "calendarDragHint": "ਵਧਾਉਣ ਲਈ ਖਿੱਚੋ ↕"
  }
}
